/**
 * Copyright (c) NCR Terafina
 **/
import Cookies from 'js-cookie';
import { AnalyticsService } from './AnalyticsService';
/**
 * Authentication Service
 *
 */
export const AuthService = {
  isAuthenticated: false,
  validate() {
    const token = Cookies.get('X-Authorization');

    if (this.isAuthenticated) {
      return Promise.resolve(true);
    }

    if (
      location.hostname === 'localhost' ||
      location.hostname.startsWith('192') ||
      location.hostname.startsWith('127')
    ) {
      AnalyticsService.track({
        userPurpose: 'Development',
        client: 'API_LOCALHOST',
      });
      return Promise.resolve(true);
    }

    if (!token) {
      return Promise.resolve(false);
    }

    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: token },
    };

    return fetch('https://omeio.terafinainc.net/api/security/session/npm', requestOptions)
      .then((resp) => {
        return resp.json().then((data) => {
          AnalyticsService.track({
            userPurpose: data.purpose,
            client: data.customerCode && data.customerCode.toUpperCase(),
          });
          const token1 = resp.headers.get('Authorization');
          if (token1) {
            Cookies.set('X-Authorization', token1, {
              path: '/',
              domain: 'terafinainc.net',
              secure: true,
              expires: 1,
            });
            this.isAuthenticated = true;
            return Promise.resolve(true);
          } else {
            return Promise.resolve(false);
          }
        });
      })
      .catch((err) => {
        console.log(err);
        return Promise.resolve(false);
      });
  },
  login(token: string) {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token: token }),
    };

    return fetch('https://omeio.terafinainc.net/api/security/session/npm', requestOptions)
      .then((resp) => {
        return resp.json().then((data) => {
          AnalyticsService.track({
            userPurpose: data.purpose,
            client: data.customerCode && data.customerCode.toUpperCase(),
          });
          const token1 = resp.headers.get('Authorization');
          if (token1) {
            Cookies.set('X-Authorization', token1, {
              path: '/',
              domain: 'terafinainc.net',
              secure: true,
              expires: 1,
            });

            this.isAuthenticated = true;
            return Promise.resolve(true);
          } else {
            return Promise.resolve(false);
          }
        });
      })
      .catch((err) => {
        console.log(err);
        return Promise.resolve(false);
      });
  },
  logout() {
    Cookies.remove('X-Authorization');
    this.isAuthenticated = false;
    return Promise.resolve(true);
  },
};
